<template>
	<div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
		<div class="popup-bg rounded-xl shadow-2xl w-full max-w-lg p-6 animate-scale-in relative">

			<!-- Back button -->
			<button @click="$emit('back')" class="absolute top-4 left-4 p-2 rounded-full hover:bg-[var(--hover-bg-color)] transition" >
				<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[var(--text-color)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
				</svg>
			</button>

			<svg class="wallet-icon mx-auto mb-4" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="2" fill="none">
				<rect x="4" y="20" width="56" height="28" rx="4" fill="var(--accent-color-10)" stroke="var(--accent-color)"/>
					<g class="flap">
						<path d="M4 20h20v-8H4z" fill="var(--accent-color-30)" stroke="var(--accent-color)"/>
					</g>
				<circle cx="50" cy="34" r="4" fill="var(--accent-color-50)" />
				<g class="money">
					<line x1="16" y1="32" x2="44" y2="32" stroke-linecap="round"/>
					<line x1="16" y1="36" x2="44" y2="36" stroke-linecap="round"/>
				</g>
			</svg>

			<h1 class="text-3xl font-archivomedium mb-4 text-center text-[var(--text-color)]">
				Awaiting deposit
			</h1>

			<p class="text-center font-archivoregular text-[var(--text-color)] mb-6">
				We will let you know as soon as your deposit is received. This can take up to 2 business days.
			</p>

			<p class="text-center font-archivolight text-sm text-[var(--text-color)] my-6">
				Just as a reminder, this is your unique deposit reference:
			</p>

			<!-- ref block -->
			<div class="border border-[var(--accent-color)] bg-[var(--accent-color-20)] rounded-lg p-4 mb-6 text-center">
				<p class="text-xl font-archivosemibold text-[var(--accent-color)] break-words">
					{{ depositReference }}
				</p>
			</div>

			<div class="flex justify-center items-center mx-auto">
				<button @click="onConfirm" class="px-6 py-2 rounded-full bg-[var(--accent-color)] border border-[var(--accent-color)] text-white hover:bg-transparent hover:text-[var(--accent-color)] transition">
					Confirm Deposit
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	const props = defineProps({
		currentTheme: String,
		depositReference: String,
		withdrawalAddress: Object
	});

	const emit = defineEmits(['back','confirm']);

	function onConfirm() {
		emit('confirm', props.withdrawalAddress);
	}
</script>

<style scoped>
	.popup-bg { background: var(--popup-bg-color); }

	@keyframes flapSwing {
		0%,100%  { transform: rotate(0deg);    }
		50% { transform: rotate(-5deg);   }
	}
	.flap {
		transform-origin: 4px 20px;
		animation: flapSwing 2.5s ease-in-out infinite;
	}

	/* money lines slight slide */
	@keyframes moneySlide {
		0%,100% { transform: translateX(0); }
		50% { transform: translateX(-2px); }
	}

	.money line {
		stroke: var(--accent-color);
		animation: moneySlide 1.5s ease-in-out infinite;
	}

	/* gentle pulse on entire wallet */
	@keyframes walletPulse {
		0%,100% { transform: scale(1);   opacity: 0.8; }
		50% { transform: scale(1.03); opacity: 1;   }
	}

	.wallet-icon {
		width: 4rem;
		height: 4rem;
		color: var(--accent-color);
		animation: walletPulse 3s ease-in-out infinite;
	}
</style>